<template>
  <ViewWrapper headingText="Terminals">
    <Terminals></Terminals>
  </ViewWrapper>
</template>

<script>
import ViewWrapper from '@/components/ViewWrapper'
import Terminals from '@/components/manage/Terminals'

export default {
  components: { ViewWrapper, Terminals }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/TerminalsPage.vue